import { Flex, Image, Text } from "@chakra-ui/react";
import { Stepper, Step } from "components/stepper";
import { motion } from "framer-motion";
import React, { useMemo } from "react";
import { AVAILABLE_WIDTH } from "views/admin/campaign_create/roas";
import { useCampaignCreate } from "views/admin/campaign_create/roas/components/CampaignCreateContext";
import { useStep } from "views/admin/campaign_create/roas/components/StepContext";

const RoasStepper = () => {
  const { setStep, step, steps } = useStep();
  const stepsWithCompletion: Step[] = steps.map((s, index) => ({
    ...s,
    isCompleted: s.isCompleted || false,
  }));

  return (
    <Flex
      pos="fixed"
      bottom={0}
      py={8}
      alignSelf={"center"}
      w={`calc(${AVAILABLE_WIDTH})`}
      px={`calc(${AVAILABLE_WIDTH} / 10)`}
      bgColor="whiteAlpha.500"
      zIndex={100}
      boxShadow="md"
      _hover={{ bgColor: "white" }}
      transition="0.5s ease 0s"
      borderRadius={"md"}
      gap={16}
    >
      <Stepper
        steps={stepsWithCompletion}
        currentStep={step}
        onClick={setStep}
      />
    </Flex>
  );
};

export default RoasStepper;
